/*
 * @Date: 2023-12-29 15:02:49
 * @Author: jm
 * @LastEditTime: 2024-01-02 18:20:21
 * @LastEditors: jm
 * @FilePath: \gameclub\src\pages\home\router.js
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./views/Home.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
